module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":{"load_more_recruitment_information":"さらに会社説明会を読み込む"}}}')
  delete Component.options._Ctor
}
